import React from 'react';
import { gql, ReleaseMintsModalDocument, useInfiniteQuery } from '@graphql/reactQuery';
import { UserList } from './shared/UserList';

/*#__PURE__*/ gql(/* GraphQL */ `
  query ReleaseMintsModal($releaseId: UUID!, $pagination: ReleaseCollectorCursorConnectionArgs!) {
    release(id: $releaseId) {
      id
      totalMinted
      collectorsCount
      collectors(pagination: $pagination) {
        edges {
          node {
            id
            ...CollectorModalInfo
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`);

export const ReleaseMintsModal = ({ releaseId }: { releaseId: string }) => {
  const {
    orderedList,
    loadMoreNextPage,
    isLoadingNewPage,
    firstPage: data,
  } = useInfiniteQuery(ReleaseMintsModalDocument, {
    variables({ pageParam }) {
      return {
        releaseId,
        pagination: {
          first: 10,
          after: pageParam?.after || null,
        },
      };
    },
    filterQueryKey: {
      releaseId,
    },
    getNextPageParam({ data }) {
      return (
        data?.release?.collectors.pageInfo.hasNextPage && {
          after: data?.release?.collectors.pageInfo.endCursor,
        }
      );
    },
    list({ release }) {
      return release?.collectors.edges.map(edge => edge.node);
    },
    uniq({ id }) {
      return id;
    },
    staleTime: 0,
  });

  const release = data?.data.release;
  const numMints = release?.totalMinted;
  const numCollectors = release?.collectorsCount;

  return (
    <UserList
      collectorList={orderedList}
      isLoading={isLoadingNewPage}
      loadMore={loadMoreNextPage}
      primaryCount={numMints}
      primaryItem="edition"
      primarySubordinate="minted"
      secondaryCount={numCollectors}
      secondaryItem="collector"
      sourceLocation="Release Mints Modal"
    />
  );
};
